import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const venturesModule = namespace('ventures');
let StarshipsVentures = class StarshipsVentures extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = this.isInBook ? 'Customization Options | Starships' : 'Starship Ventures';
    }
    created() {
        this.fetchVentures();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.ventures)
            .map(venture => ({
            ...venture,
            id: venture.name,
            isExpandable: venture.content
        })).value();
    }
    get allPrerequisites() {
        return _.chain(this.ventures)
            .flatMap(({ prerequisites }) => prerequisites)
            .sortBy(prerequisite => {
            const splitPrerequisite = prerequisite.split(' ');
            return splitPrerequisite[splitPrerequisite.length - 1];
        })
            .concat(['None'])
            .value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Prerequisites',
                value: 'prerequisites',
                render: (prerequisites) => _.upperFirst(prerequisites.join(', ') || '-'),
                isMultiSelect: true,
                filterChoices: this.allPrerequisites,
                filterFunction: ({ prerequisites }, filterValue) => _.some(filterValue, (filter) => _.includes(prerequisites, filter)) ||
                    (_.includes(filterValue, 'None') && prerequisites.length === 0)
            }
        ];
    }
};
__decorate([
    venturesModule.State
], StarshipsVentures.prototype, "ventures", void 0);
__decorate([
    venturesModule.Action
], StarshipsVentures.prototype, "fetchVentures", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StarshipsVentures.prototype, "isInBook", void 0);
StarshipsVentures = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], StarshipsVentures);
export default StarshipsVentures;
